import store from "@/store"
// import ContentCache from "../integration/ContentCache"

// import { localeToProperties } from "@/utils"

export default async (to, from, next) => {
  // request route-specific content if the main content request is still pending
  // if (!store.state.content.hasFullContent) {
  //   store
  //     .dispatch(
  //       "content/FETCH_CONTENT",
  //       `${localeToProperties(store.state.locale.locale).pathPrefix}${to.path}`
  //     )
  //     .catch(() => {
  //       console.log("path error - waiting for full content")
  //       store.watch(
  //         state => state.content.hasFullContent,
  //         val => {
  //           if (val === true) {
  //             return
  //           }
  //         }
  //       )
  //     })
  // }

  store.commit("content/SET_IMAGE_MANIFEST", [])
  next()
}
